<template>
  <div>
    <h5 class="title" v-if="loading">仓库加载中...</h5>
    <h5 class="title" v-else>欢迎回来，请选择一个仓库进行操作</h5>
    <div class="module-list">
      <div
        class="li"
        v-for="(item, index) in stockroomList"
        :key="index"
        @click="choseStockroom(item)"
      >
        <div class="panel">
          <div class="panel-body text-center">
            <!-- <div class="text-main module-icon">
                    <i class="icon-2x" :class="item.icon_class"></i>
                  </div> -->
            <div class="text-lg text-semibold mar-no text-main module-content">
              <p class="module-name">{{ item.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { stockroomList, updateUserCurrentStockroom } from '@/service/getData'
import { getStore, setStore } from '@/config/mUtils'
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      stockroomList: [],
      loading: true,
    }
  },
  created() {
    this.getUserStockroomList()
  },
  computed: {
    redirectUrl() {
      return this.$route.query.redirect_url || ''
    },
  },
  methods: {
    ...mapMutations(['RECORD_USERINFO']),
    async getUserStockroomList() {
      let res = await stockroomList({
        user_id: getStore('userInfo').id,
      })

      if (res.status == 0) {
        let userInfo = getStore('userInfo')
        userInfo.is_stockroom_admin = res.data.list.length > 0
        setStore('userInfo', userInfo)
        if (res.data.list.length <= 1) {
          this.$router.push(this.redirectUrl)
        } else {
          this.stockroomList = res.data.list
          this.loading = false
        }
      }
    },

    async choseStockroom(item) {
      let res = await updateUserCurrentStockroom({ stockroom_id: item.id })
      if (res.status == 0) {
        this.$router.push(this.redirectUrl)
      }
    },
  },
}
</script>

<style scoped>
.title {
  margin-top: 80px;
  margin-bottom: 20px;
  /* color: #bfc5cf; */
  font-size: 20px;
  font-weight: 400;
}
.module-list {
  display: flex;
  flex-wrap: wrap;
}

.module-list .li {
  width: 30%;
  max-width: 300px;
  margin-right: 5%;
  margin-bottom: 30px;
  cursor: pointer;
}

.module-name {
  margin-bottom: 0;
  font-size: 20px;
}
.panel-body {
  padding-top: 40px;
  padding-bottom: 40px;
}
</style>